import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { MID_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: { display: "flex", flexDirection: "column" },
  rootActions: {
    borderBottom: `1px solid ${MID_GREY}`,
  },
}));
